import React from 'react';
import { Button, ButtonGroup, Col, Form, Row } from 'react-bootstrap';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Table } from 'react-bootstrap';
// import { Table } from "react-bootstrap"
import { useTable, usePagination } from 'react-table';

export function Result({ columns, serverData }) {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [pageCount, setPageCount] = React.useState(0)
  const fetchIdRef = React.useRef(0)
  const fetchData = React.useCallback(({ pageSize, pageIndex }) => {
    const fetchId = ++fetchIdRef.current
    setLoading(true)
    setTimeout(() => {
      if (fetchId === fetchIdRef.current) {
        const startRow = pageSize * pageIndex
        const endRow = startRow + pageSize
        setData(serverData.slice(startRow, endRow))
        setPageCount(Math.ceil(serverData.length / pageSize))
        setLoading(false)
      }
    }, 1000)
  }, [serverData])
  return (
    <TableC
      columns={columns}
      data={data}
      fetchData={fetchData}
      loading={loading}
      pageCount={pageCount}
      countAllData={serverData.length}
    />

  )

}

export function TableC({ columns, data, fetchData, loading, pageCount: controlledPageCount, countAllData }) {
  const { getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }, } = useTable({
      columns,
      data,
      initialState: { pageIndex: 0 },
      manualPagination: true,
      pageCount: controlledPageCount,
      countAllData: countAllData
    },
      usePagination)

  React.useEffect(() => {
    fetchData({ pageIndex, pageSize })
  }, [fetchData, pageIndex, pageSize])

  // Render the UI for your table
  return (
    <>
      <Table hover responsive  {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th className='text-center' {...column.getHeaderProps({ style: { minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth, textAlign: column.align } })}>
                  {column.render('Header')}

                </th>
              ))}
            </tr>
          ))}
        </thead>
        {loading ? (<tbody><tr><td className="text-center p-5" colSpan="10000">درحال دریافت اطلاعات ...</td></tr></tbody>)
          :
          (
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return <td className='text-center' {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    })}
                  </tr>
                )
              })}
            </tbody>
          )}
      </Table>
      <Row className="py-4 mb-5 table-footer">
        <Col xs={12} sm={6} md={3} lg={6} xl={2} className=" my-auto">{page.length} از  {countAllData} رکورد </Col>
        <Col xs={12} sm={6} md={5} lg={6} xl={4} className="text-sm-right my-auto text-xl-left">
          تعداد صفحات : <strong>{pageOptions.length}</strong> |
                    بروبه صفحه <Form.Control size="sm" className="d-inline-block text-center" style={{ width: '60px' }} type="text"
            value={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }} />
        </Col>
        <Col xs={12} sm={6} md={4} lg={6} xl={3} className="text-md-right text-lg-left mt-3 mt-xl-0 my-auto">
          <span className="text-small mt-4 mt-sm-0">  نمایش هر صفحه: </span>
          <Form.Control as="select" size="sm" className="d-inline-block" style={{ width: '60px' }}
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value))
            }}>
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col xs={12} sm={6} md={12} lg={6} xl={3} className="text-sm-right pl-md-0">
          <ButtonGroup className="ml-sm-3 mt-3 mt-xl-0 d-flex justify-content-between">
            <Button variant="secondary" size="sm" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              <LastPage />
            </Button>
            <Button variant="secondary" onClick={() => previousPage()} disabled={!canPreviousPage}>
              <ChevronRight />
            </Button>
            <Button variant="dark" className="disable" disabled={true}>
              {pageIndex + 1}
            </Button>

            <Button variant="secondary" onClick={() => nextPage()} disabled={!canNextPage}>
              <ChevronLeft />
            </Button>
            <Button variant="secondary" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
              <FirstPage />
            </Button>
          </ButtonGroup>

        </Col>
      </Row>

    </>
  )
}
